import { useState, useEffect } from 'react';
import { pwaInstallationManager, PWAInstallationState } from '../utils/pwaInstallation';

export const usePWAInstallation = () => {
  const [state, setState] = useState<PWAInstallationState>(
    pwaInstallationManager.getState()
  );
  const [isInstalling, setIsInstalling] = useState(false);

  useEffect(() => {
    const unsubscribe = pwaInstallationManager.addListener(setState);
    return unsubscribe;
  }, []);

  const promptInstall = async () => {
    setIsInstalling(true);
    try {
      const result = await pwaInstallationManager.promptInstall();
      return result;
    } finally {
      setIsInstalling(false);
    }
  };

  return {
    ...state,
    isInstalling,
    promptInstall,
    canShowInstallButton: pwaInstallationManager.canShowInstallButton(),
    canShowManualInstallInstructions: pwaInstallationManager.canShowManualInstallInstructions(),
    manualInstallInstructions: pwaInstallationManager.getManualInstallInstructions()
  };
};